// @ts-ignore
import $ from 'jquery';
export const initMultiSelectFields = (column) => {
    column.getElement().querySelectorAll('select[multiple]').forEach(select => {
        new MultiSelect(column, select);
    });
};
class MultiSelect {
    constructor(column, select) {
        this.column = column;
        this.select = select;
        this.bindEvents();
    }
    bindEvents() {
        // First remove all cloned Select2 elements
        this.select.removeAttribute('data-select2-id');
        this.select.parentElement.querySelectorAll('.select2').forEach(el => {
            el.remove();
        });
        $(this.select).ac_select2({
            theme: 'acs2',
            width: '100%',
            escapeMarkup: function (text) {
                return text;
            },
        });
    }
}
